/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { GetBalanceState200ResponsePredictedDailyBalanceTransitionListInnerActivitiesInner } from './get-balance-state200-response-predicted-daily-balance-transition-list-inner-activities-inner';

/**
 * 
 * @export
 * @interface GetBalanceState200ResponsePredictedDailyBalanceTransitionListInner
 */
export interface GetBalanceState200ResponsePredictedDailyBalanceTransitionListInner {
    /**
     * 
     * @type {string}
     * @memberof GetBalanceState200ResponsePredictedDailyBalanceTransitionListInner
     */
    'targetDate': string;
    /**
     * 
     * @type {number}
     * @memberof GetBalanceState200ResponsePredictedDailyBalanceTransitionListInner
     */
    'balance': number;
    /**
     * 
     * @type {number}
     * @memberof GetBalanceState200ResponsePredictedDailyBalanceTransitionListInner
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof GetBalanceState200ResponsePredictedDailyBalanceTransitionListInner
     */
    'length': number;
    /**
     * 
     * @type {string}
     * @memberof GetBalanceState200ResponsePredictedDailyBalanceTransitionListInner
     */
    'type': GetBalanceState200ResponsePredictedDailyBalanceTransitionListInnerTypeEnum;
    /**
     * 
     * @type {Array<GetBalanceState200ResponsePredictedDailyBalanceTransitionListInnerActivitiesInner>}
     * @memberof GetBalanceState200ResponsePredictedDailyBalanceTransitionListInner
     */
    'activities': Array<GetBalanceState200ResponsePredictedDailyBalanceTransitionListInnerActivitiesInner>;
    /**
     * 
     * @type {number}
     * @memberof GetBalanceState200ResponsePredictedDailyBalanceTransitionListInner
     */
    'balanceWithGuaranteeMoney': number;
}

export const GetBalanceState200ResponsePredictedDailyBalanceTransitionListInnerTypeEnum = {
    payBill: 'PAY_BILL',
    deposit: 'DEPOSIT',
    withdrawal: 'WITHDRAWAL',
    reward: 'REWARD',
    usageFee: 'USAGE_FEE',
    point: 'POINT',
    cardPoint: 'CARD_POINT',
    campaignPoint: 'CAMPAIGN_POINT',
    card: 'CARD',
    depositFromGuaranteeMoney: 'DEPOSIT_FROM_GUARANTEE_MONEY',
    withdrawalToGuaranteeMoney: 'WITHDRAWAL_TO_GUARANTEE_MONEY',
    serviceCharge: 'SERVICE_CHARGE'
} as const;

export type GetBalanceState200ResponsePredictedDailyBalanceTransitionListInnerTypeEnum = typeof GetBalanceState200ResponsePredictedDailyBalanceTransitionListInnerTypeEnum[keyof typeof GetBalanceState200ResponsePredictedDailyBalanceTransitionListInnerTypeEnum];


